import React from "react";
import ListItem from 'theme/ListItem';

export const viewportAwareListItem = ( { key, onPress, style = {}, children } = {} ) => {
	
	const props = {};
	if( onPress ) {
		props['onPress'] = onPress;
	}
	
	return (
		<ListItem
			key={ key }
			{ ...props }
			style={ style }>
			
			{ children }
		</ListItem>
	);
}
